import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('./vacation-homework/index.vue')
// const AiTeacher = () => import('./vacation-homework/AiTeacherPage.vue')

export const indexRoute: RouteConfig = {
  path: '/winter-vacation-homework-2024',
  name: 'winter_vacation_homework_2024',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '寒假作业',
    ignoreLogin: true,
  },
}
// export const aiRoute: RouteConfig = {
//   path: '/winter-vacation-homework-2024-ai',
//   name: 'winter_vacation_homework_2024_ai',
//   component: AiTeacher,
//   props: (route) => ({ ...route.query, ...route.params }),
//   meta: {
//     title: 'AI体育老师',
//     ignoreLogin: true,
//   },
// }

export default [indexRoute]

export function navigateToWinterVacation2024Homework(router: VueRouter, qd?: string) {
  router.push({ name: indexRoute.name, query: { qd } })
}
